const getBlueskyShareUrl = (language, state) => {
    const pageUrl = new URL(process.env.REACT_APP_API_HOST);
    pageUrl.searchParams.set('lang', language);
    if (state) {
        pageUrl.searchParams.set('state', state);
    }

    return `https://bsky.app/intent/compose?text=${encodeURIComponent(
        pageUrl.toString(),
    )}`;
};

export default getBlueskyShareUrl;
